import { render, staticRenderFns } from "./DocumentSummary.vue?vue&type=template&id=e0dab200&scoped=true&"
import script from "./DocumentSummary.vue?vue&type=script&lang=js&"
export * from "./DocumentSummary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSummary.vue?vue&type=style&index=0&id=e0dab200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dab200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0dab200')) {
      api.createRecord('e0dab200', component.options)
    } else {
      api.reload('e0dab200', component.options)
    }
    module.hot.accept("./DocumentSummary.vue?vue&type=template&id=e0dab200&scoped=true&", function () {
      api.rerender('e0dab200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/components/DocumentSummary.vue"
export default component.exports